import { isEqual } from 'lodash'
import * as sdpTransform from 'sdp-transform'
import { store } from 'store'

export const firstLetterUpper = (string) => {
    return string[0].toUpperCase() + string.slice(1)
}

export const stripDisabledCodecs = (codecs) => {
    const result = []

    codecs.forEach((item) => {
        if (item.enabled) {
            const { enabled, ...props } = item
            result.push({ ...props })
        }
    })

    return result
}

/* Get supported codecs array from dummy peer connection sdp */
export const getCodecCapabilities = async (stream) => {
    const rawSdp = await getPeerConnectionSDP(stream)
    const sdp = sdpTransform.parse(rawSdp)
    const audio = sdp.media.find((item) => item.type === 'audio')

    const audioCodecs = audio.rtp.map((item) => {
        return {
            ...item,
            name: firstLetterUpper(item.codec),
            mimeType: `audio/${item.codec}`,
            channels: item.encoding || 1
        }
    })

    return audioCodecs
}

/* Get dummy peerconnection session description */
export const getPeerConnectionSDP = async (stream) => {
    try {
        const pc = new RTCPeerConnection({
            offerToReceiveAudio: true,
            offerToReceiveVideo: false,
            iceServers: []
        })

        stream.getTracks().forEach((track) => pc.addTrack(track, stream))

        const { sdp } = await pc.createOffer()
        return sdp
    } catch (e) {
        console.error(e)
        return null
    }
}

/* Check if 2 codecs are the same thing by codec, rate, encoding properties */
export const isSameCodec = (firstCodec, secondCodec) => {
    const { codec, rate, encoding } = firstCodec
    const { codec: codec2, rate: rate2, encoding: encoding2 } = secondCodec

    return isEqual({ codec, rate, encoding }, { codec: codec2, rate: rate2, encoding: encoding2 })
}

export const prepareSdpAudio = (audio) => {
    const { codecPreferences } = store.getState().settings
    const codecsEnabled = stripDisabledCodecs(codecPreferences)

    if (codecsEnabled?.length) {
        const { rtp, fmtp, rtcpFb } = audio

        const toEnablePayloads = []
        const toEnableCodecs = []
        const toEnableFmtp = []
        const toEnableRtcpFb = []

        rtp.forEach((rtpItem) => {
            if (codecsEnabled.some((codec) => isSameCodec(rtpItem, codec))) {
                toEnablePayloads.push(rtpItem.payload)
                toEnableCodecs.push(rtpItem)
            }
        })

        if (toEnablePayloads?.length) {
            fmtp?.length &&
                fmtp.forEach((fmtpItem) => {
                    if (toEnablePayloads.some((codecPayload) => codecPayload === fmtpItem.payload)) {
                        toEnableFmtp.push(fmtpItem)
                    }
                })

            rtcpFb?.length &&
                rtcpFb.forEach((rtcpFbItem) => {
                    if (toEnablePayloads.some((codecPayload) => codecPayload === rtcpFbItem.payload)) {
                        toEnableRtcpFb.push(rtcpFbItem)
                    }
                })

            audio.payloads = toEnablePayloads.join(' ')
            audio.fmtp = toEnableFmtp
            audio.rtp = toEnableCodecs
            audio.rtcpFb = toEnableRtcpFb
        }
    }

    return audio
}
